import axios, { type AxiosRequestConfig } from 'axios'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.withCredentials = true

const token: string | null = window.PnBaseData.security.csrfToken ?? null

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token
}

export type EndpointType = {
    method: string
    url: string
}

export function addPrecognitionHeaders(headers: AxiosRequestConfig['headers'], fields?: string[]) {
    if (fields) {
        headers = {
            ...headers,
            Precognition: 'true',
        }

        if (fields.length) {
            headers = {
                ...headers,
                'Precognition-Validate-Only': fields,
            }
        }
    }

    return headers
}

export default axios
